import { render } from "./MulpumV5V5.vue?vue&type=template&id=49adf1ba&scoped=true"
import script from "./MulpumV5V5.vue?vue&type=script&lang=js"
export * from "./MulpumV5V5.vue?vue&type=script&lang=js"

import "./MulpumV5V5.vue?vue&type=style&index=0&id=49adf1ba&scoped=true&lang=css"
import "./MulpumV5V5.vue?vue&type=style&index=1&id=49adf1ba&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49adf1ba"]])

export default __exports__